const Debug =  {
    log: function(...rest) {
        process.env.PRODUCTION ? null : console.log(...rest) ;
    }
};

export default Debug;